import { render } from "./index.vue?vue&type=template&id=289a5718&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=289a5718&lang=scss"
import "./index.vue?vue&type=style&index=1&id=289a5718&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-289a5718"],['__file',"src/components/ToolbarTextEditor/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "289a5718"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('289a5718', __exports__)) {
    console.log('reload')
    api.reload('289a5718', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=289a5718&scoped=true", () => {
    console.log('re-render')
    api.rerender('289a5718', render)
  })

}


export default __exports__